module.exports = __webpack_public_path__ + "img/super.6aa707b7.png";